// UsernameTag.js
import { connect } from 'react-redux';
import UsernameTag from '../component/UsernameTag.jsx';

import fetchUserByUsername from '../action/fetchUserByUsername.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getUserDataByUsername from '../selector/getUserDataByUsername.js';

const mapStateToProps = (state, { username }) => {
  return {
    username,
    error: getNetworkingData(state, ['user', username], 'error'),
    userId: getUserDataByUsername(state, username, 'id'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchUserByUsername: username =>
      dispatch(fetchUserByUsername({ username })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UsernameTag);
